// Colourway dots on Living collection cards. Living has no real variants (one product per SKU), so each dot is a
// link to a sibling PRODUCT. Clicking one swaps the card in place (image, title, price, links) and keeps the link
// behaviour for new-tab / no-JS. Defined once, however many cards embed the script tag.
if (!customElements.get('family-swatches')) {
  customElements.define(
    'family-swatches',
    class FamilySwatches extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const dot = event.target.closest('a[data-url]');

          if (!dot || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

          const card = this.closest('product-card');

          if (!card || dot.classList.contains('is-selected')) return;

          event.preventDefault();

          const image = card.querySelector('.product-card__image--primary');

          if (image && dot.dataset.image) {
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.src = dot.dataset.image;
          }

          const secondary = card.querySelector('.product-card__image--secondary');

          if (secondary) secondary.remove();

          card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
            if (!link.closest('family-swatches')) link.href = dot.dataset.url;
          });

          const title = card.querySelector('.product-title');

          if (title && dot.dataset.title) title.textContent = dot.dataset.title;

          const price = card.querySelector('.price-list');

          if (price && dot.dataset.price) price.outerHTML = dot.dataset.price;

          this.querySelectorAll('a[data-url]').forEach((link) => {
            link.classList.toggle('is-selected', link === dot);
          });
        });
      }
    }
  );
}